import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import randomstring from 'uuid/v4';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Switch from '@material-ui/core/Switch';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Close from '@material-ui/icons/Close';

class Filter extends React.Component {
    state = {
        lastWeek: this.props.lastWeek,
        from: this.props.from,
        to: this.props.to,
        ended: this.props.ended,
        local: this.props.local,
    };

    handleRemoveDate = (nombre) => (event) => {
        this.setState({ [nombre]: '' });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked });
    };

    handleClose = (lastWeek, from, to, ended, local) => (event) => {
        this.props.handleClose(lastWeek, from, to, ended, local);
    };

    render() {
        const { from, to, ended, local, lastWeek } = this.state;
        const { intl, info } = this.props;
        const nodes = info.security.locals.reduce((arr, c) => {
            if (info.security.localPermits[c.id] && info.security.localPermits[c.id].length > 0) {
                arr.push(c);
            }
            return arr;
        }, []);

        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_32 align_center">
                        <div className="flex_full_column">
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="lastWeek" />
                            </div>
                        </div>
                        <div className="flex_auto_column">
                            <Switch
                                name={'lastWeek'}
                                checked={lastWeek}
                                onChange={this.handleChecked}
                                value="lastWeek"
                                color="primary"
                            />
                        </div>
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            fullWidth
                            name={'from'}
                            id={'from-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_init_label' })}
                            type="date"
                            disabled={lastWeek}
                            value={from ? from : ''}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                        <Close
                            className="c_lipstick hand"
                            onClick={this.handleRemoveDate('from')}
                        />
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <TextField
                            fullWidth
                            name={'to'}
                            id={'to-date'}
                            label={intl.formatMessage({ id: 'form_field_add_date_end_label' })}
                            type="date"
                            disabled={lastWeek}
                            value={to ? to : ''}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                        <Close
                            className="c_lipstick hand"
                            onClick={this.handleRemoveDate('to')}
                        />
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <div className="flex_full_column">
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="ended" />
                            </div>
                        </div>
                        <div className="flex_auto_column">
                            <Switch
                                name={'ended'}
                                checked={ended}
                                onChange={this.handleChecked}
                                value="ended"
                                color="primary"
                            />
                        </div>
                    </div>
                    <div className="flex_full_row margin_top_32 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {nodes &&
                                    nodes.map((cat) => {
                                        return (
                                            <option key={randomstring()} value={cat.id}>
                                                {cat.name}
                                            </option>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(true, null, null, null)} color="primary">
                        <FormattedMessage id="remove" />
                    </Button>
                    <Button
                        onClick={this.handleClose(lastWeek, from, to, ended, local)}
                        color="primary"
                        autoFocus
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
    info: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

Filter = connect(
    mapStateToProps,
    null,
)(Filter);

Filter = injectIntl(Filter);

export default Filter;



// WEBPACK FOOTER //
// ./src/components/complex/families/FilterMenu.js